<!-- @format -->

<template>
  <div>
    <VRow>
      <v-col cols="6">
        <VRow>
          <template v-if="getPermissionMixin('credits')">
            <VCol cols="6" md="4" lg="6">
              <CountItem
                color="green"
                icon="mdi-comment"
                title="تعداد پیامک های باقی مانده (آسانک)"
                :count="creaditsModel.asanak.credit"
              />
            </VCol>
            <VCol cols="6" md="4" lg="6">
              <CountItem
                color="blue"
                icon="mdi-cash"
                title="     شارژ باقی مانده (کاوه نگار)"
                :count="`${Math.round(
                  creaditsModel.kavenegar.credit
                ).toLocaleString()} ریال`"
              />
            </VCol>
            <VCol cols="6" md="4" lg="3">
              <CountItem
                color="blue"
                icon="mdi-calendar"
                title="تاریخ انقضای کاوه نگار"
                :count="
                  creaditsModel.kavenegar.expire &&
                  creaditsModel.kavenegar.expire == 0
                    ? '------'
                    : getPersianDate(creaditsModel.kavenegar.expire)
                "
              />
            </VCol>
            <VCol cols="6" md="4" lg="3">
              <CountItem
                color="blue"
                icon="mdi-calendar"
                title="شارژ پنل زیبال"
                :count="showZibal(creaditsModel.zibal.credit)"
              />
            </VCol>
          </template>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              color="green"
              icon="mdi-truck-check-outline"
              title="  رانندگان آنلاین"
              :count="onlineDrivers"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              color="green"
              icon="mdi-account-group"
              title="کاربران آنلاین"
              :count="onlineUsers"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              route="/drivers/turns"
              color="green"
              icon="mdi-book"
              title="رزرو های فعال"
              :count="reservationCount"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              route="/remittance"
              color="blue"
              icon="mdi-book-arrow-down"
              title="حواله های جاری"
              :count="remittanceCount"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              route="/orders"
              color="blue"
              icon="mdi-book-arrow-down"
              title="اعلام بار های فعال"
              :count="orderCount"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <div class="text-purple-500 bg-purple-100"></div>
            <div class="text-fuchsia-500 bg-fuchsia-100"></div>
            <div class="text-amber-500 bg-amber-100"></div>
            <div class="text-sky-500 bg-sky-100"></div>
            <CountItem
              route="/drivers"
              color="purple"
              icon="mdi-card-account-details"
              title="رانندگان"
              :count="driverCount"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              route="/carslist"
              color="red"
              icon="mdi-truck"
              title="ناوگان"
              :count="carCount"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              route="/companies"
              color="fuchsia"
              icon="mdi-office-building"
              title="شرکت ها"
              :count="companyCount"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              route="/realPersonFactories"
              color="yellow"
              icon="mdi-account-group"
              title="کاربران"
              :count="factoryRealPersonCount"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              route="/factories"
              color="amber"
              icon="mdi-office-building"
              title="واحد های صنفی"
              :count="factoryLegalPersonCount"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              route="/access/admins"
              color="green"
              icon="mdi-account-circle"
              title="ادمین ها"
              :count="adminCount"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              route="/receipts"
              color="sky"
              icon="mdi-comment-multiple"
              title="فیش های در انتظار"
              :count="pendingReceipt"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              route="/support"
              color="yellow"
              icon="mdi-comment-eye"
              title="تیکت های باز"
              :count="openTicket"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              route="/carbreakdown"
              color="stone"
              icon="mdi-car-cog"
              title="اعلام خرابی"
              :count="carBreakdownCount"
            />
          </VCol>
        </VRow>
      </v-col>
      <VCol cols="6">
        <div id="map" class="min-h-[60vh] h-full">
          <mapir
            ref="map"
            :apiKey="mapirToken"
            :center="coordinates"
            :zoom="zoom"
          >
            <mapMarker
              ref="markers"
              v-for="item in remittances"
              :key="item.id"
              :coordinates="item.location.coordinates"
              color=""
              @click="hover(item)"
            />
            <mapNavigationControl position="top-right" />
          </mapir>
        </div>
      </VCol>
      <VCol cols="12">
        <v-card class="shadow">
          <RemittanceTable
            :customHeaders="headersTable"
            :isCustom="true"
            title="حواله های جاری"
            :notExcl="false"
            :exc-data="remittances"
            :exc-columns="columns"
            :notFilter="true"
            :showPages="true"
            @updateTable="getRemittance($route.params.driverId)"
            :remittanceHistory="remittances"
          >
            <template #default="{ item }">
              <div class="flex justify-start align-center">
                <button
                  @click="focusDriverOnMap(item.id)"
                  class="w-8 h-8 hover:bg-green-100 rounded-lg bg-green-50 text-green-500"
                >
                  <VIcon style="color: inherit">mdi-map-marker-account</VIcon>
                </button>

                <router-link
                  v-if="getPermissionMixin('remittance-history-point')"
                  :to="{
                    name: 'remittanceTracking',
                    params: {
                      id: item.id,
                    },
                  }"
                >
                  <button
                    @click="focusDriverOnMap(item.id)"
                    class="w-8 h-8 hover:bg-green-100 flex justify-center items-center mr-2 rounded-lg bg-green-50 text-green-500"
                  >
                    <img width="22" src="../../assets/svg/trkcking2.png" />
                  </button>
                </router-link>

                <ShowWaibill
                  v-if="item.path"
                  :itemId="item.remittanceHistory_id"
                />
              </div>
            </template>
          </RemittanceTable>
          <div>
            <Pagination v-model="page" :total="total" :currentView="per_page" />
          </div>
        </v-card>
      </VCol>
    </VRow>

    <v-dialog v-model="dialog" max-width="390">
      <v-card>
        <v-card-title style="justify-content: center"> اطلاعات </v-card-title>
        <v-card-text>
          <div>
            <div class="mt-3">
              نام راننده :
              <span class="text-bold text-blue-950">{{ name }}</span>
            </div>
            <div class="mt-3">
              فامیل راننده :
              <span class="text-bold text-blue-950">{{ family }}</span>
            </div>
            <div class="mt-3">
              تاریخ ایجاد :
              <span class="text-bold text-blue-950">{{ created_at }}</span>
            </div>
            <div class="mt-3">
              کالا :
              <span class="text-bold text-blue-950">{{ productTitle }}</span>
            </div>
            <div class="mt-3">
              گیرنده :
              <span class="text-bold text-blue-950">{{
                receiverDetailNameFamily
              }}</span>
            </div>
            <div class="mt-3">
              شماره تلفن :
              <span class="text-bold text-blue-950">{{ mobile }}</span>
            </div>
            <div class="mt-3">
              مبدا : <span class="text-bold text-blue-950">{{ source }}</span>
            </div>
            <div class="mt-3">
              مقصد :
              <span class="text-bold text-blue-950">{{ destination }}</span>
            </div>
            <div class="mt-3">
              اخرین زمان به روز رسانی :
              <span class="text-bold text-blue-950">{{ time }}</span>
            </div>
            <div class="mt-3 flex items-center">
              <span> استعلام اخرین بارنامه : </span>
              <button
                @click="goToLastWayBill(plaque)"
                type="button"
                class="rounded-lg hover:bg-blue-100 bg-blue-50 py-2 text-blue-500 mt-2 mr-1 w-[40px]"
              >
                <v-icon style="color: inherit">mdi-book-search-outline</v-icon>
              </button>
            </div>
            <div class="mt-3">
              <Plaque :plaque="plaque" />
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class="whiteButton"
            text
            @click="dialog = false"
          >
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { convertDateOnly } from "@/plugins/getPersianDate";
import CountItem from "@/components/Dashboard/CountItem.vue";
import { mapir, mapNavigationControl, mapMarker } from "mapir-vue";
import axiosApi from "@/plugins/axios";
import Plaque from "@/components/Plaque.vue";
import RemittanceTable from "@/components/Remittance/RemittanceTable.vue";
import Pagination from "@/components/Pagination.vue";
import ShowWaibill from "@/components/showWaibill.vue";
export default {
  name: "index",
  components: {
    mapir,
    RemittanceTable,
    mapNavigationControl,
    Pagination,
    Plaque,
    mapMarker,
    ShowWaibill,
    CountItem,
    convertDateOnly,
  },
  data() {
    return {
      seri: [],
      chartOption: {},
      dateArray: [],
      remittanceCount: 0,
      driverCount: 0,
      reservationCount: 0,
      onlineDrivers: 0,
      onlineUsers: 0,
      companyCount: 0,
      factoryRealPersonCount: 0,
      factoryLegalPersonCount: 0,
      adminCount: 0,
      pendingReceipt: 0,

      carCount: 0,
      openTicket: 0,
      carBreakdownCount: 0,
      orderCount: 0,
      role: "",
      dates: "",
      show: false,
      countDay: "",
      coordinates: [52.4034788, 34.6213794],
      remittances: [],
      zoom: 4,
      loading: false,
      creaditsModel: {
        zibal: {
          credit: 0,
        },
        kavenegar: {
          credit: 0,
          expire: 0,
        },
        asanak: {
          credit: 0,
        },
      },
      page: 0,
      per_page: 0,
      total: 0,
      headersTable: [
        { text: "نام", value: "driver.name" },
        { text: "فامیل", value: "driver.family" },
        { text: "مبدا", value: "source_province.title" },
        { text: "مقصد", value: "destination_province.title" },
        { text: "گیرنده", value: "receiverDetailNameFamily" },
        { text: "تاریخ بارگیری", value: "created_at" },
        { text: "کالا", value: "productTitle" },
        { text: "پلاک", value: "driver.plaque" },
        { text: "اخرین بروزرسانی", value: "updated_at" },
        { text: "عملیات", value: "operations" },
      ],
      columns: [
        { lable: "نام", field: "driver.name" },
        { lable: "فامیل", field: "driver.family" },
        { lable: "مبدا", field: "source_province.title" },
        { lable: "مقصد", field: "destination_province.title" },
        { lable: "گیرنده", field: "receiverDetailNameFamily" },
        { lable: "تاریخ بارگیری", field: "created_at" },
        { lable: "کالا", field: "productTitle" },
        { lable: "پلاک", field: "driver.plaque" },
        { lable: "اخرین بروزرسانی", field: "updated_at" },
        { lable: "عملیات", field: "operations" },
      ],
      mapirToken:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjBiYWJhMmZjODJkZDkxZDUwMGE3YTY3MWYwZGI1NzBkYWIwM2E4MTVhYjMxZmQ0NzYzMjM3MDI1NGU4NTkyODgwMGY5YWQxOTVhYzI0YmMwIn0.eyJhdWQiOiIxODAyOSIsImp0aSI6IjBiYWJhMmZjODJkZDkxZDUwMGE3YTY3MWYwZGI1NzBkYWIwM2E4MTVhYjMxZmQ0NzYzMjM3MDI1NGU4NTkyODgwMGY5YWQxOTVhYzI0YmMwIiwiaWF0IjoxNjUzMjEzMDUxLCJuYmYiOjE2NTMyMTMwNTEsImV4cCI6MTY1NTgwNTA1MSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.n9UC78jfMrUmHUMANsa9WAwH0zNehBngBRWRAONUpqpDmAfTWUK6tI5Oyl-Cek51YBFwYcFpmQXH21PliNOQ_2IK6_GtU65HsyQA5qHW6mPAS0zrhrx4TH0maFrdORynZ1XTWedKfX0pNXOSUgY2nUMwRcECQ0NfPV86wsTK3-OlG9bN-BmsIujOKrCPbus8ue3F9oFfDmmQ7ZXFBA92UWH2vmCsQK_JABEPKJNocsb_d5wblZ9wVl03rCk6AppBOBJ2TNvgnUlmqttihfLMnoHIlSFxi4_M7ydb9nhdgHeM1FqAgDaD3-iBLO31tq_zlO8DU9vnwGQ3ZTMxAaIDWg",
      dialog: false,
      name: "",
      family: "",
      plaque: "",
      created_at: "",
      receiverDetailNameFamily: "",
      productTitle: "",
      mobile: "",
      source: "",
      destination: "",
      time: "",
      timer: "",
    };
  },
  mounted() {
    this.tracking();
    this.timer = setInterval(() => {
      this.tracking();
      if (this.role === "ADMIN") {
        this.getCount();
      }
    }, 5000);
    if (
      this.getPermissionMixin("credits") &&
      localStorage.getItem("role") == "ADMIN"
    ) {
      this.getCreadits();
    }
    this.getRole();
    if (this.role === "ADMIN") {
      this.getCount();
    }
    if (localStorage.getItem("role") == null) {
      localStorage.clear();
      location.replace("/");
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getRole() {
      this.role = localStorage.getItem("role");
    },
    getCreadits() {
      axiosApi()
        .get("v2/admin/credits")
        .then((result) => {
          // console.log(result);
          this.creaditsModel = result.data.data;
        })
        .finally(() => (this.loading = false));
    },
    getCount() {
      this.loading = true;
      axiosApi()
        .get("v2/admin/dashboard")
        .then((result) => {
          this.driverCount = result.data.data.driverCount;
          this.reservationCount = result.data.data.reservationCount;
          this.onlineDrivers = result.data.data.onlineDrivers;
          this.onlineUsers = result.data.data.onlineUsers;
          this.remittanceCount = result.data.data.RemittanceCount;
          this.carCount = result.data.data.carCount;
          this.factoryRealPersonCount = result.data.data.factoryRealPersonCount;
          this.factoryLegalPersonCount =
            result.data.data.factoryLegalPersonCount;
          this.companyCount = result.data.data.company;
          this.openTicket = result.data.data.openTicket;
          this.carBreakdownCount = result.data.data.carBreakdownCount;
          this.orderCount = result.data.data.orderCount;
          this.adminCount = result.data.data.adminCount;

          this.orderCount = result.data.data.orderCount;

          this.dates = result.data.data.dates.reverse();
          this.countDay = result.data.data.date_count.reverse();

          this.seriesDonut = [
            result.data.data.factoryLegalRegisterToday,
            result.data.data.factoryRealRegisterToday,
            result.data.data.companyRegisterToday,
            result.data.data.driverRegisterToday,
          ];

          this.seri = [
            {
              name: "تعداد ثبت نام",
              data: this.countDay,
            },
          ];
          this.chartOption = {
            // colors: ['#9155fd'],
            chart: {
              type: "area",
              background: "#f8fafc",
              fontFamily: "iranYekanBold, sans-serif",
              foreColor: "#a8a29e",
              zoom: {
                autoScaleYaxis: true,
                enabled: true,
                type: "x",
              },
              toolbar: {
                autoSelected: "pan",
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: false,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset:
                    true | '<img src="/static/icons/reset.png" width="20">',
                },
              },
            },
            dataLabels: {
              enabled: false,
            },
            fill: {
              gradient: {
                enabled: true,
                opacityFrom: 0.55,
                opacityTo: 0,
              },
            },
            xaxis: {
              type: "text",
              categories: this.dates,
              labels: {
                rotate: -0,
              },
              tickAmount: 4,
              max: this.dates.length,
              min: this.dates.length - 5,
              floating: true,
            },
            yaxis: {
              floating: true,
              min: 0,
              tickAmount: 5,
            },
            stroke: {
              width: "3",
              curve: "smooth",
            },
            markers: {
              size: 5,
              colors: ["#fff"],
              strokeColor: "#00BAEC",
              strokeWidth: 3,
            },
            grid: {
              yaxis: {
                lines: {
                  show: false,
                },
              },
              padding: {
                left: 30,
                bottom: 30,
              },
              borderColor: "#ececec",
            },
          };
        })
        .finally(() => (this.loading = false));
    },

    showZibal(val) {
      if (typeof val == "string") {
        return val;
      } else {
        return Math.round(val).toLocaleString() + " " + " ریال";
      }
    },
    goToLastWayBill(item) {
      this.$router.push("inquiry/lastWayBill/PELAK/" + item);
    },

    focusDriverOnMap(id) {
      const driver = this.remittances.find((i) => i.id === id);
      const selectedMarker = document.querySelector(".map-marker.selected");
      if (selectedMarker) {
        selectedMarker.classList.remove("selected");
      }
      for (const marker of this.$refs.markers) {
        if (
          marker.marker._lngLat.lng == driver.location.coordinates[0] &&
          marker.marker._lngLat.lat == driver.location.coordinates[1]
        ) {
          marker.marker._element.classList.add("selected");
        }
      }

      this.$refs.map.map.easeTo({
        zoom: 10,
        center: [...driver.location.coordinates],
      });
      document.getElementById("map").scrollIntoView();
    },
    tracking() {
      axiosApi()
        .get("v2/admin/remittance/tracking")
        .then((result) => {
          this.remittances = result.data.data.remittance;
          this.remittances = this.remittances.filter((item) => {
            return item.location !== null;
          });
        });
    },
    hover(item) {
      this.dialog = !this.dialog;
      this.name = item.driver.name;
      this.family = item.driver.family;
      this.mobile = item.driver.mobile;
      this.receiverDetailNameFamily = item.receiverDetailNameFamily;
      this.productTitle = item.productTitle;
      this.created_at = this.getPersianDate(item?.created_at);
      this.plaque = item.plaque;
      this.source = item?.source_province.title;
      this.destination = item?.destination_province.title;
      this.time = this.getPersianDate(item?.updated_at);
    },
  },
};
</script>

<style>
.map-marker {
  background-image: url("../../assets/track.svg");

  width: 30px;
  height: 30px;
}

.selected {
  background-image: url("../../assets/truck-32.png") !important;
  background-position: center center !important;
  background-size: 30px 30px !important;

  /* filter: invert(1); */
  /* background-color: #ff7d00 !important; */
  /* padding: 5px !important; */
}
</style>
